import React, { forwardRef } from 'react';

export const SuccessButton = forwardRef(function SuccessButton(props, ref) {
  const {icon} = props;
  return (
    <button
      ref={ref}
      className="btn btn-success rounded-pill"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
      <i className={"fw-bold far ms-2 "+ (icon ? icon : "fa-check-circle")}></i>
    </button>
  );
})

export const DangerButton = forwardRef(function DangerButton(props, ref) {
  const { icon } = props;
  return (
    <button
      className="btn btn-danger rounded-pill"
      ref={ref}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children} 
      <i className={"fw-bold fas ms-2 " + (icon ? icon : 'fa-window-close') }></i>
    </button>
  );
})

export function PrimaryButton(props) {
  const { icon, className, children, ...rest} = props;
  return (
    <button
      className={"btn btn-primary rounded-pill " + className}
      {...rest}
    >
      {children}
      <i className={"fw-bold fas ms-2 " + ( icon ? icon : '')} ></i>
    </button>
  );
}

export function InfoButton(props) {
  const { icon, children, className, ...rest } = props;
  return (
    <button
      className={"btn btn-info rounded-pill " + className}
      {...rest}
    >
      {children}
      <i className={"fw-bold fas ms-2 " + ( icon ? icon : '')} ></i>
    </button>
  );
}

export function WarningButton(props) {
  const { icon } = props;
  return (
    <button
      className="btn btn-warning rounded-pill"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
      <i className={"fw-bold fas ms-2 " + ( icon ? icon : '')} ></i>
    </button>
  );
}